import { Route, Routes } from "react-router-dom";
import { NotFoundPublic } from './ComponentSplit';
import ProtectedRoute from './ProtectedRoute';
import { RoutePrivateList, RoutePublicList } from './routes';

export default function Navigations() {
    // const api = async () => {
    //     const response = await CallApi({
    //         url: `${BaseUrl}/update`,
    //         method: 'get',
    //         token: auth.token
    //     })
    //     if (!response.error) {
    //         dispatch(setUpdateSlice(response.data.data))
    //     }
    // }

    // useEffect(() => {
    //     api()
    // }, [])

    return (

        <Routes>
            <Route path='*' element={<NotFoundPublic />} />
            {RoutePublicList.map((route) => <Route path={route.path} element={route.element} key={route.path} />)}
            {RoutePrivateList.map((route) => {
                return <Route path={route.path} element={
                    <div
                        onCopy={(e) => false}
                        onPaste={(e) => false}
                        onSelect={(e) => false}
                        onCut={(e) => false}
                        onDrag={(e) => false}
                        onDrop={(e) => false}
                    ><ProtectedRoute>{route.element}</ProtectedRoute></div>
                } key={route.path} />
            })}

        </Routes>
    )
}